import '@material/web/icon/icon.js'
import './new-board-popup.js'

import { css, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import { i18next, localize } from '@operato/i18n'
import { openPopup } from '@operato/layout'

@customElement('new-board-card')
export class BoardCreationCard extends localize(i18next)(LitElement) {
  static get styles() {
    return [
      css`
        :host {
          display: flex;
          border: var(--card-list-create-border);
          border-radius: var(--card-list-create-border-radius);

          background-color: var(--md-sys-color-surface);

          align-content: center;
          justify-content: center;
        }

        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          font-size: 0.8em;
          color: var(--card-list-create-color);
          text-transform: capitalize;
        }

        md-icon {
          --md-icon-size: 42px;
          display: block;
          font-size: 3.5em;
          color: var(--card-list-create-icon-color);
        }
      `
    ]
  }

  /* default group id */
  @property({ type: String }) defaultGroup?: string
  @property({ type: Array }) groups: any

  private popup: any

  render() {
    return html`<div @click=${(e: Event) => this.onClick()}><md-icon>add_circle_outline</md-icon>create board</div> `
  }

  onClick() {
    if (this.popup) {
      delete this.popup
    }

    /*
     * 기존 설정된 이미지가 선택된 상태가 되게 하기 위해서는 selector에 value를 전달해줄 필요가 있음.
     * 주의. value는 object일 수도 있고, string일 수도 있다.
     * string인 경우에는 해당 보드의 id로 해석한다.
     */
    var template = html`
      <new-board-popup
        .defaultGroup=${this.defaultGroup}
        .groups=${this.groups}
        @create-board=${async (e: CustomEvent) => {
          var { name, description, groupId, model, thumbnail } = e.detail

          this.dispatchEvent(
            new CustomEvent('create-board', {
              detail: {
                name,
                description,
                groupId,
                model,
                thumbnail
              }
            })
          )

          this.popup && this.popup.close()
        }}
      ></new-board-popup>
    `

    this.popup = openPopup(template, {
      backdrop: true,
      size: 'large',
      title: i18next.t('title.create-board')
    })
  }

  reset() {}
}
